"use client";

import { useRouter } from "next/navigation";
import { ShoppingCart, User } from "lucide-react";
import { useCart } from "../data/CartContext";
import Link from "next/link";

const CartLogin = () => {
  const { cart } = useCart(); // ✅ Get cart data
  const router = useRouter(); // ✅ Router for navigation

  const handleCartClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault(); // Prevent default link behavior

    if (cart.length === 0) {
      alert("🛒 Your cart is empty! Redirecting to shop...");
      router.push("/shop"); // ✅ Redirect to shop
    } else {
      router.push("/shop/cart"); // ✅ Go to cart page
    }
  };

  return (
    <div className="flex items-center space-x-6 pr-10">
      {/* Login Icon */}
      <Link href="/account" aria-label="Account">
        <User
          className="text-[var(--text-on-dark)] hover:text-[var(--accent-light)] cursor-pointer h-5 w-5 md:h-6 md:w-6"
          aria-hidden
        />
      </Link>

      {/* Cart Icon with Conditional Click */}
<a href="#" onClick={handleCartClick} className="relative" aria-label="View cart">
  <ShoppingCart
    className="text-[var(--text-on-dark)] hover:text-[var(--accent-light)] cursor-pointer h-5 w-5 md:h-6 md:w-6"
    aria-hidden
  />
  {cart.length > 0 && (
    <span className="absolute -top-2 -right-3 bg-[var(--accent)] text-[var(--ink)] text-xs px-2 py-1 rounded-full" aria-hidden>
      {cart.reduce((total, item) => total + item.qty, 0)}
    </span>
  )}
</a>
    </div>
  );
};

export default CartLogin;